<template>
  <div class="container-fluid mt-5">
    <div
      class="d-flex flex-wrap flex-column flex-sm-row mb-3 justify-content-between"
    >
      <div class="">
        <div class="d-flex align-items-center">
          <div class="s-32 font-weight-bold text-head text-black">
            Asset Requests
          </div>
        </div>
        <BackRoute />
      </div>
      <div class="d-flex flex-column flex-sm-row link">
        <el-button
          @click="assetRequestModal"
          :color="primarycolor"
          class="header-btn w-100 mt-3 mt-sm-0"
          round
        >
          New request
        </el-button>
      </div>
    </div>
    <div class="row">
      <div class="container-fluid px-0 mt-5">
        <div class="col-md-12" v-loading="loading">
          <div v-if="filteredData.length > 0">
            <TableNoExport2
              :data="filteredData"
              :headers="AssetRequestHeaders"
              @update:searchText="handleSearchTextUpdate"
              :checkMultipleItem="false"
              :filterItem="false"
            >
              <template v-slot:assetCode="{ item }">
                <div class="c-pointer fw-400" @click="editRequest(item)">
                  {{ item && item.asset ? item.asset.assetCode : "" }}
                </div>
              </template>
              <template v-slot:name="{ item }">
                <div class="c-pointer fw-400" @click="editRequest(item)">
                  {{ item && item.asset ? item.asset.name : "" }}
                </div>
              </template>
              <template v-slot:category="{ item }">
                <div class="c-pointer fw-400" @click="editRequest(item)">
                  {{
                    item.asset && item.asset.category
                      ? item.asset.category.name
                      : ""
                  }}
                </div>
              </template>
              <template v-slot:approvedBy="{ item }">
                <div class="c-pointer fw-400" @click="editRequest(item)">
                  {{ item.approvedBy ? item.approvedBy.firstName : "" }}
                </div>
              </template>
              <template v-slot:requestedBy="{ item }">
                <div class="c-pointer fw-400" @click="editRequest(item)">
                  {{ item.requestedBy ? item.requestedBy.firstName : "" }}
                </div>
              </template>
              <template v-slot:status="{ item }">
                <div class="c-pointer fw-400" @click="editRequest(item)">
                  {{ requestStatus[item.status].label }}
                </div>
              </template>
              <template v-slot:dateApproved="{ item }">
                <div class="c-pointer fw-400" @click="editRequest(item)">
                  {{ date(item.dateApproved) }}
                </div>
              </template>
              <template v-slot:action="{ item }">
                <el-dropdown trigger="click">
                  <el-icon>
                    <MoreFilled />
                  </el-icon>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item>
                        <div class="text-color" @click="editRequest(item)">
                          Edit
                        </div>
                      </el-dropdown-item>

                      <el-dropdown-item>
                        <div class="text-color" @click="deleteRequest(item.id)">
                          Delete
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </TableNoExport2>
          </div>

          <!-- Show message when there's no data -->
          <div v-else class="text-center py-5">
            <el-empty description="No asset requests available" />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      v-model="displayModal"
      :title="null"
      :width="mdAndUp || lgAndUp || xlAndUp ? '50%' : '90%'"
      class="border-radius-8"
      :close-on-click-modal="false"
    >
      <div class="p-4">
        <h5 class="font-weight-600 s-24 text-dak mb-4">
          {{ isEditing ? "Edit Asset Request" : "New Asset Request" }}
        </h5>

        <div class="row align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Asset Name</label>
          </div>
          <div class="col-md-9">
            <el-select-v2
              v-model="selectedAssetId"
              @change="setSelectedAsset"
              :options="
                assets.map((i) => ({
                  label: i.name,
                  value: i.id,
                }))
              "
              placeholder="Select"
              size="large"
              class="w-100"
            />
          </div>
        </div>

        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Requested by</label>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-5">
                <!-- <el-select-v2
                  v-model="form.requestedBy"
                  :options="
                    users.map((i) => ({
                      label: i,
                      value: i,
                    }))
                  "
                  placeholder="Select"
                  size="large"
                  class="w-100"
                /> -->
                <div class="input-width">
                  <MembersSearch
                    @memberdetail="requestedContact"
                    :currentMember="requestedByInfo"
                  />
                </div>
              </div>
              <div class="col-md-7">
                <div class="row align-items-center">
                  <div class="col-md-3 text-md-right text-left">
                    <label class="fw-400 s-16 mr-3 text-dak">Date</label>
                  </div>
                  <div class="col-md-9">
                    <el-date-picker
                      v-model="form.date"
                      type="date"
                      format="MM/DD/YYYY"
                      size="large"
                      class="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Approved by</label>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-5">
                <!-- <el-select-v2
                  v-model="form.approvedBy"
                  :options="
                    users.map((i) => ({
                      label: i,
                      value: i,
                    }))
                  "
                  placeholder="Select"
                  size="large"
                  class="w-100"
                /> -->

                <MembersSearch
                  @memberdetail="approvedContact"
                  :currentMember="approvedByInfo"
                />
              </div>
              <div class="col-md-7">
                <div class="row align-items-center">
                  <div class="col-md-3 text-md-right text-left">
                    <label class="fw-400 s-16 mr-3 text-dak">Status</label>
                  </div>
                  <div class="col-md-9">
                    <el-select-v2
                      v-model="form.status"
                      :options="
                        requestStatus.map((i) => ({
                          label: i.label,
                          value: i.value,
                        }))
                      "
                      placeholder="Select"
                      size="large"
                      class="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Comment</label>
          </div>
          <div class="col-md-9">
            <el-input
              v-model="form.comment"
              :rows="5"
              type="textarea"
              class="w-100"
              placeholder="Enter your note here"
            />
          </div>
        </div>
        <div class="row mt-4 justify-content-center align-items-center">
          <div class="col-md-3 text-md-right text-left"></div>
          <div class="col-md-5">
            <el-button
              round
              :color="primarycolor"
              class="w-100 text-white"
              @click="handleSubmit"
            >
              {{ isEditing ? "Update & Continue" : "Save & Continue" }}
            </el-button>
            <el-button round link class="w-100 text-dak" @click="closeModal">
              Close
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, inject, computed, onMounted } from "vue";
import BackRoute from "../../components/backroute/BackRoute.vue";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import TableNoExport2 from "../../components/table/TableNoExport2.vue";
import assetService from "../../services/asset/assetServices";
import { ElNotification, ElMessageBox } from "element-plus";
import MembersSearch from "../../components/membership/MembersSearch.vue";
import monthDayYear from "../../services/dates/dateformatter";

const primarycolor = inject("primarycolor");
const { mdAndUp, lgAndUp, xlAndUp } = deviceBreakpoint();

const searchText = ref("");
const selectedAssetId = ref(null);
const selectedAsset = ref({});
const requestedByInfo = ref({});
const approvedByInfo = ref({});
const displayModal = ref(false);
const loading = ref(false);
const textHead = ref("All requests");

// TABLE HEADERS
const AssetRequestHeaders = ref([
  { name: "ASSET CODE", value: "assetCode" },
  { name: "ASSET NAME", value: "name" },
  { name: "CATEGORY", value: "category" },
  // { name: "REQUEST DATE", value: "requestDate" },
  { name: "APPROVED BY", value: "approvedBy" },
  { name: "REQUESTED BY", value: "requestedBy" },
  { name: "STATUS", value: "status" },
  { name: "DATE APPROVED", value: "dateApproved" },
  { name: "ACTION", value: "action" },
]);

// DYNAMIC DATA
const assetRequestData = ref([]);
const users = ref([]);
const assets = ref([]);
const isEditing = ref(false);
const editRequestId = ref(null);
const requestStatus = [
  { label: "Pending", value: 0 },
  { label: "Approved", value: 1 },
  { label: "Declined", value: 2 },
];

// FORM DATA
const form = ref({
  assetName: "",
  requestedBy: "",
  approvedBy: "",
  date: "",
  status: "",
  comment: "",
});

const editRequest = async (item) => {
  try {
    isEditing.value = true;
    editRequestId.value = item.id;

    // Fetch full request details from API
    const response = await assetService.getRequestById(item.id);
    const requestData = response || {};

    // Populate form fields
    selectedAssetId.value = requestData.asset?.id || null;
    selectedAsset.value = requestData.asset || {};

    requestedByInfo.value = {
      id: requestData.requestedBy?.id || requestData.requestedById,
      name: requestData.requestedBy
        ? `${requestData.requestedBy.firstName} ${requestData.requestedBy.lastName}`
        : "",
    };

    approvedByInfo.value = {
      id: requestData.approvedBy?.id || requestData.approvedById,
      name: requestData.approvedBy
        ? `${requestData.approvedBy.firstName} ${requestData.approvedBy.lastName}`
        : "",
    };

    form.value = {
      assetName: requestData.asset?.name || "",
      requestedBy: requestedByInfo.value.name,
      approvedBy: approvedByInfo.value.name,
      date: requestData.dateRequested || "",
      status: requestData.status ?? null,
      comment: requestData.comment || "",
    };

    displayModal.value = true;
  } catch (error) {
    console.error("Error fetching request by ID:", error);
    ElNotification({
      type: "error",
      message: "Failed to load request details",
      duration: 5000,
    });
  }
};

const closeModal = () => {
  displayModal.value = false;
  // form.value = "";
};

const requestedContact = (payload) => {
  // form.value.requestedBy = payload.name;
  requestedByInfo.value = payload;
};
const approvedContact = (payload) => {
  // form.value.approvedBy = payload.name;
  approvedByInfo.value = payload;
};

const setSelectedAsset = () => {
  selectedAsset.value = assets.value.find((asset) => {
    return asset.id === selectedAssetId.value;
  });
};

const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};

// OPEN MODAL
const assetRequestModal = () => {
  displayModal.value = true;
  form.value = {
    date: "",
    status: null,
    comment: "",
  };
  selectedAssetId.value = null;
  isEditing.value = false;
  editRequestId.value = null;
  approvedByInfo.value.name = "";
  requestedByInfo.value.name = "";
};
const loadAssets = async () => {
  try {
    const response = await assetService.getAssets();
    assets.value = response; // Adjust mapping if backend structure differs
  } catch (error) {
    console.error("Error fetching assets:", error);
  }
};
loadAssets();
const deleteRequest = async (id) => {
  try {
    await ElMessageBox.confirm(
      "Are you sure you want to delete this request?",
      "Confirm delete",
      {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "error",
      }
    );
    await assetService.deleteRequest(id);
    ElNotification({
      type: "success",
      message: "Request deleted successfully",
    });
    fetchIssues(); // Refresh table after deletion
  } catch (error) {
    if (error !== "cancel") {
      console.error("Error deleting Request:", error);
      ElNotification({
        type: "error",
        message: "Failed to delete Request",
      });
    }
  }
};

// FETCH ASSET REQUESTS
const getAssetRequests = async () => {
  loading.value = true;
  try {
    const response = await assetService.getRequests();
    assetRequestData.value = response || [];
    loading.value = false;
  } catch (error) {
    console.error("Error fetching asset requests:", error);
    // ElNotification({
    //   type: "error",
    //   message: "Failed to load asset requests",
    //   duration: 5000,
    // });
    loading.value = false;
  }
};

// CREATE NEW REQUEST
const handleSubmit = async () => {
  try {
    const payload = {
      assetId: selectedAsset.value ? selectedAsset.value.id : null,
      requestedById: requestedByInfo.value ? requestedByInfo.value.id : null,
      approvedById: approvedByInfo.value ? approvedByInfo.value.id : null,
      dateRequested: form.value.date,
      status: form.value.status,
      comment: form.value.comment,
    };

    if (isEditing.value && editRequestId.value) {
      // Update existing request
      await assetService.updateRequest(editRequestId.value, payload);
      ElNotification({
        type: "success",
        message: "Request updated successfully",
        duration: 5000,
      });
    } else {
      // Create new request
      await assetService.createRequest(payload);
      ElNotification({
        type: "success",
        message: "Request created successfully",
        duration: 5000,
      });
    }

    displayModal.value = false;
    isEditing.value = false;
    editRequestId.value = null;
    getAssetRequests(); // Refresh table
  } catch (error) {
    console.error("Error saving request:", error);
    ElNotification({
      type: "error",
      message: "Failed to save request",
      duration: 5000,
    });
  }
};

// SEARCH FILTER
const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};
const filteredData = computed(() => {
  if (!assetRequestData.value || !Array.isArray(assetRequestData.value))
    return [];
  if (!searchText.value.trim()) return assetRequestData.value;
  return assetRequestData.value.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.value.toLowerCase())
  );
});

// ON PAGE LOAD
onMounted(() => {
  getAssetRequests();
  // If needed, fetch users and assets
});
</script>
